import { render } from "./CMSLogin.vue?vue&type=template&id=6b3979de"
import script from "./CMSLogin.vue?vue&type=script&lang=js"
export * from "./CMSLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__